import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, ViewChild } from '@angular/core';

import { LogService } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'ridango-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
    @Input() size = '460';
    @Input() visible = false;
    @Input() isItSmall = false;
    @Input() visibleCloseIcon = true;
    @Input() outsideClickAllowed = true;
    @Output() onCloseModal = new EventEmitter<any>();
    @Output() onConfirmModal = new EventEmitter<any>();

    @ViewChild('firstFocus') firstFocus: ElementRef; // element to focus on when modal opened

    showFocusOutline = false;

    constructor(
        @Inject('ENV') public env: Env,
        public eRef: ElementRef
    ) {}

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (event.target.className.indexOf('modal-fade-overlay') >= 0) {
            if (this.outsideClickAllowed) {
                this.closeModal();
            }
        }
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (this.visible) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                this.closeModal();
            }
        }
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        this.showFocusOutline = true;
    }

    @HostListener('document:click', ['$event']) handleMouseEvent(event: MouseEvent) {
        this.showFocusOutline = false;
    }

    closeModal() {
        this.onCloseModal.emit();
    }
    confirmModal() {
        this.onConfirmModal.emit();
    }
}
